import { useEffect, useState } from 'react';
const xIcon = '/icons/close.svg';

function MenuParams(props) {
  const { estimagasDispatch, estimagasState, tableDispatch } = props;
  var params = estimagasState.params;
  const setParams = (payload) =>
    estimagasDispatch({ type: 'SET_PARAMS', payload: payload });

  const [OXInput, setOXInput] = useState(params.OX);
  const [fyInput, setFyInput] = useState(params.fy);
  const [MCFInput, setMCFInput] = useState(params.MCF);
  const [FInput, setFInput] = useState(params.F);
  const [kjiInput, setKjiInput] = useState(params.kji);
  const [gravimetria, setGravimetria] = useState(params.gravimetria);

  function findOXValue(e) {
    if (e.target.checked) { // Verifica se o radio está selecionado
      if (e.target.id === 'OX-0') setOXInput(0);
      if (e.target.id === 'OX-0.1') setOXInput(0.1);
    }
  }

  function findMCFValue(e) {
    if (e.target.checked) { // Verifica se o radio está selecionado
      switch (e.target.id) {
        case 'MCF-1':
          setMCFInput(1);
          break;
        case 'MCF-0.8':
          setMCFInput(0.8);
          break;
        case 'MCF-0.5':
          setMCFInput(0.5);
          break;
        case 'MCF-0.4':
          setMCFInput(0.4);
          break;
        default:
          break;
      }
    }
  }

  function findKJIValue(e) {
    if (e.target.checked) { // Verifica se o radio está selecionado
      switch (e.target.id) {
        case 'kji-1':
          setKjiInput(0);
          break;
        case 'kji-2':
          setKjiInput(1);
          break;
        case 'kji-3':
          setKjiInput(2);
          break;
        case 'kji-4':
          setKjiInput(3);
          break;
        default:
          break;
      }
    }
  }

  // Função para salvar os parâmetros
  function handleSaveParams() {
    setParams({
      fy: fyInput,
      OX: OXInput,
      F: FInput,
      MCF: MCFInput,
      kji: kjiInput,
      gravimetria: gravimetria,
    });

    // Fecha o menu após salvar
    tableDispatch({ type: 'TOGGLE_MENU_PARAMS' });
  }

    return (
      <div
        className={
          'absolute bg-stone-100 top-[6.88rem] left-[20vw] w-[60vw] flex z-[3] border-2 border-blue-600 rounded-md align-middle'
        }
      >
        {/* Coluna 2 */}
        <div className="flex-1 p-4 border-r border-gray-200">
          <p className="menuparams-p text-blue-900 font-medium text-sm underline underline-offset-4">
            Metano capturado:
          </p>
          <div className="flex items-center mb-4">
            <input
              type="range"
              min="0"
              max="100"
              defaultValue={fyInput * 100}
              onChange={(e) => setFyInput(parseFloat(e.target.value) / 100)}
              className="w-full h-2 bg-blue-600 rounded-lg appearance-none cursor-pointer"
            />
            <input
              type="text"
              value={(fyInput * 100).toFixed(0) + '%'}
              readOnly={true}
              className="w-16 ml-2 px-2 py-1 rounded-md border border-orange-500 text-blue-600 font-semibold text-lg text-center focus:outline-none"
            />
          </div>
  
          <p className="menuparams-p text-blue-900 font-medium text-sm underline underline-offset-4">
            Fração de metano no biogás:
          </p>
          <div className="flex items-center mb-4">
            <input
              type="range"
              min="0"
              max="100"
              defaultValue={FInput * 100}
              onChange={(e) => setFInput(parseFloat(e.target.value) / 100)}
              className="w-full h-2 bg-blue-600 rounded-lg appearance-none cursor-pointer"
            />
            <input
              type="text"
              value={(FInput * 100).toFixed(0) + '%'}
              readOnly={true}
              className="w-16 ml-2 px-2 py-1 rounded-md border border-orange-500 text-blue-600 font-semibold text-lg text-center focus:outline-none"
            />
          </div>
  
          {/* Radio Group - OX */}
          <div onChange={(e) => findOXValue(e)} className="mb-4 space-y-2">
            <p className="menuparams-p text-blue-900 font-medium text-sm underline underline-offset-4">
              Fator de oxidação da camada de cobertura:
            </p>
            <label
              htmlFor="OX-0"
              className="flex items-center cursor-pointer ml-10"
            >
              <input
                id="OX-0"
                type="radio"
                name="OX-radio"
                className="w-4 h-4 border border-blue-600 rounded-full mr-2 inline-block align-middle"
              />
              0
            </label>
            <label
              htmlFor="OX-0.1"
              className="flex items-center cursor-pointer ml-10"
            >
              <input
                id="OX-0.1"
                type="radio"
                name="OX-radio"
                defaultChecked="true"
                className="w-4 h-4 border border-blue-600 rounded-full mr-2 inline-block align-middle"
              />
              0.1
            </label>
          </div>
  
          {/* Radio Group - MCF */}
          <div onChange={(e) => findMCFValue(e)} className="mb-4 space-y-2">
            <p className="menuparams-p text-blue-900 font-medium text-sm underline underline-offset-4">
              Fração de metano no biogás:
            </p>
            <label className="flex items-center cursor-pointer  ml-10">
              <input
                id="MCF-1"
                type="radio"
                name="MCF-radio"
                defaultChecked="true"
                className="w-4 h-4 border border-blue-600 rounded-full mr-2 inline-block align-middle"
              />
              1
            </label>
            <label
              htmlFor="MCF-0.8"
              className="flex items-center cursor-pointer  ml-10"
            >
              <input
                id="MCF-0.8"
                type="radio"
                name="MCF-radio"
                className="w-4 h-4 border border-blue-600 rounded-full mr-2 inline-block align-middle"
              />
              0.8
            </label>
            <label
              htmlFor="MCF-0.5"
              className="flex items-center cursor-pointer ml-10"
            >
              <input
                id="MCF-0.5"
                type="radio"
                name="MCF-radio"
                className="w-4 h-4 border border-blue-600 rounded-full mr-2 inline-block align-middle"
              />
              0.5
            </label>
            <label
              htmlFor="MCF-0.4"
              className="flex items-center cursor-pointer ml-10"
            >
              <input
                id="MCF-0.4"
                type="radio"
                name="MCF-radio"
                className="w-4 h-4 border border-blue-600 rounded-full mr-2 inline-block align-middle"
              />
              0.4
            </label>
          </div>
        </div>
  
        {/* Decaimento */}
        <div
          onChange={(e) => findKJIValue(e)}
          className="p-4 space-y-2 flex-1"
        >
          <p className="menuparams-p text-blue-900 font-medium text-sm underline underline-offset-4">
            {' '}
            Taxa de decaimento:
          </p>
          <div className="">
            <label
              htmlFor="kji-1"
              className="flex items-center cursor-pointer "
            >
              <input
                id="kji-1"
                type="radio"
                name="KJI-radio"
                className="w-4 h-4 border border-blue-600 rounded-full mr-2 inline-block align-middle"
              />
              <p className="menuparams-p">
                  MAT ≤ 20ºC e MAP/PET '{'<'}' 1
              </p>
            </label>
            <label
              htmlFor="kji-2"
              className="flex items-center cursor-pointer"
            >
              <input
                id="kji-2"
                type="radio"
                name="KJI-radio"
                defaultChecked="true"
                className="w-4 h-4 border border-blue-600 rounded-full mr-2 inline-block align-middle"
              />
              <p className="menuparams-p">
              MAT ≤ 20ºC e MAP/PET '{'>'}' 1
              </p>
            </label>
            <label
              htmlFor="kji-3"
              className="flex items-center cursor-pointer"
            >
              <input
                id="kji-3"
                type="radio"
                name="KJI-radio"
                className="w-4 h-4 border border-blue-600 rounded-full mr-2 inline-block align-middle"
              />
              <p className="menuparams-p">
                  MAT '{'>'}' 20ºC e MAP ≤ 1000 mm
              </p>
            </label>
            <label
              htmlFor="kji-4"
              className="flex items-center cursor-pointer"
            >
              <input
                id="kji-4"
                type="radio"
                name="KJI-radio"
                className="w-4 h-4 border border-blue-600 rounded-full mr-2 inline-block align-middle"
              />
              <p className="menuparams-p">
                  MAT '{'>'}' 20ºC e MAP '{'>'}' 1000 mm
              </p>
            </label>
          </div>
        </div>

        <div className="absolute bottom-4 left-0 right-0 flex justify-center">
        <button 
          className="font-bold py-2 px-4 border-2 border-sky-500 rounded bg-emerald-500 text-stone-200"
          onClick={handleSaveParams}
        >
          Aplicar
        </button>
      </div>
  
        <img
          className="absolute top-[0.20rem] right-[0.94rem] h-8 cursor-pointer"
          src={xIcon}
          onClick={() => tableDispatch({ type: 'TOGGLE_MENU_PARAMS' })}
          alt=""
        />
      </div>
    );
  }
  
  export default MenuParams;